export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13974.25f6bcf6.jpg";